export const urlQueryKeys = {
  search: 'search',
  filter: 'filter',
  // TODO: phase out filters and transition to filter
  filters: 'filters',
} as const

export type UrlQueryKeys = typeof urlQueryKeys
export type UrlQueryKey = UrlQueryKeys[keyof UrlQueryKeys]
